import { MutableRefObject, useCallback } from 'react';
import { useAppDispatch } from 'ducks/hooks';
import { getJobsPage } from 'ducks/jobs/operators';
import { updateSuccess } from 'ducks/settings/slices';
import { AdvancedFilteringQuery, JobPageQuery } from 'ducks/types/query-types';
import { handleError } from 'utils/errors';
import { getJobState } from 'utils/queries';

export const useJobState = (
  intervalRef: MutableRefObject<NodeJS.Timer | undefined>,
  min_refresh: number | null,
  pathname: string,
  query: AdvancedFilteringQuery,
  job_state?: string,
  project_id?: number,
) => {
  const dispatch = useAppDispatch();

  const getJob = useCallback(() => {
    const jobs_location = !!pathname?.includes('jobs');
    if (!jobs_location || !min_refresh) {
      clearInterval(Number(intervalRef.current));
    }
    if (jobs_location && min_refresh) {
      intervalRef.current = setInterval(async () => {
        let queries: JobPageQuery = {
          job_state_id: null,
        };

        if (job_state) {
          const job_query = getJobState(job_state, query.include_archived);
          queries = {
            ...query,
            job_state_id: job_query.job_state_id,
            include_archived: job_query.include_archived,
          };
        }

        try {
          if (project_id) {
            await getJobsPage(project_id, queries);
          }
          dispatch(updateSuccess('Jobs have been auto refreshed'));
        } catch (err) {
          handleError(err);
        }
      }, min_refresh);
    }
  }, [dispatch, intervalRef, job_state, min_refresh, pathname, project_id, query]);

  return { getJob };
};
